module.exports = __webpack_public_path__ + "img/bingo_ball-53.9697aa60.png";